<template>
  <div class="page-wrapper">
    <div v-if="isMobile==false" class="container logo-container">
      <div class="row">
        <div class="col-12">
          <img src="@/assets/images/logo.gif"/>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row nav-container">
        <ul>
          <li><a href="#/home/">메인</a></li>
          <li><a class="active" href="#/history/">기록</a></li>
          <li><a href="#/mypage/">마이페이지</a></li>
          <li>
            <i class="fas fa-sign-out-alt logout-btn" v-on:click="logout"></i>
          </li>
        </ul>
      </div>
    </div>
    <div class="container">
      <div class="form-group row">
        <div class="col-2">
          Dates:
        </div>
        <div class="col-12 col-md-2">
          <input type="date" class="form-control" v-model="filter.date_from"/>
        </div>
        <div class="col-1">
          ~
        </div>
        <div class="col-12 col-md-2">
          <input type="date" class="form-control" v-model="filter.date_to"/>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12 col-md-2">
          송장:
        </div>
        <div class="col-12 col-md-2">
          <input type="text" class="form-control" v-model="filter.awb"/>
        </div>
        <div class="col-12 col-md-2">
          수취인:
        </div>
        <div class="col-12 col-md-2">
          <input type="text" class="form-control" v-model="filter.receiver"/>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12 col-md-4">
          <button type="button" class="btn btn-primary form-control" v-on:click="getList()">가져오기</button>
        </div>
        <div class="col-6 col-md-4">
          <div class="image-btn-container" v-on:click="downloadForCustomerH()" v-if="items.length > 0">
            <div class="image-btn"
                 :style="{backgroundImage: 'url(' + require('@/assets/images/ic_download.png') + ')'}"/>
            엑셀다운 (가로)
          </div>
          <div class="image-btn-container" v-on:click="downloadForCustomerV()" v-if="items.length > 0">
            <div class="image-btn"
                 :style="{backgroundImage: 'url(' + require('@/assets/images/ic_download.png') + ')'}"/>
            엑셀다운 (세로)
          </div>
          <div class="image-btn-container" v-on:click="getFTADocsForSelected()" v-if="selectedItems.length > 0">
            <i class="fas fa-file"></i>
            FTA
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <table class="table">
        <tr>
          <th></th>
          <th style="cursor:pointer"  v-if="isMobile==false" v-on:click="selectAll()">선택</th>
          <th>Date</th>
          <th v-on:click="sortByAWB">송장 <i class="fa fa-angle-down"></i></th>
          <th v-if="showAll">Content</th>
          <th v-on:click="sortByReceiver">수취인<i class="fa fa-angle-down"></i></th>
          <th>연락처</th>
          <th class="text-left">Description</th>
          <th>단가</th>
          <th style="display:none;">Forwarder</th>
          <th>GW</th>
          <th>CW</th>
          <th v-on:click="sortByState">상태<i class="fa fa-angle-down"></i></th>
          <th></th>
        </tr>
        <tr v-for="(item, index) in items" class="hovorable-item" v-bind:class="{'item-in-custom': item.state == 6}">
          <td>{{index+1}}</td>
          <td v-if="isMobile==false"><input type="checkbox" v-bind:value="index" v-model="selectedItems"
                                            @click="updateCheckall($event, index)"/></td>
          <td>{{item.dispatch_date}}</td>
          <td><span class="clickable-item" @click.prevent="viewItem(index)">{{item.awb}}</span></td>
          <td v-if="showAll">[{{item.brand}}] {{item.product}}</td>
          <td>{{item.receiver}}</td>
          <td>{{item.receiver_contact}}</td>
          <td class="text-left">{{getDescriptionList(item.list)}}</td>
          <td>${{item.value}}</td>
          <td style="display:none;">{{item.forwarder_string}}</td>
          <td>{{(item.measured_weight/100).toFixed(2)}}
          <td>{{(item.volume_weight/100).toFixed(2)}}
          <td v-on:click="openStatusPage(item.awb)" class="tooltip-parent" v-html="getStateTimeString(index)"></td>
          <td><span><i class="fa fa-file" v-on:click="getFTADoc(item.id)"> FTA</i></span></td>
        </tr>
      </table>
    </div>
    <transition name="vertical">
    <div class="new-item-form" v-if="newItem != false">
      <div class="scroll-container">
        <div class="container  view-with-bottom-menu">

          <div class="row">
            <div class="col-12">
              <h4>송장 #{{newItem.awb}}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="container">

                <div class="form-group row">
                  <div class="col-4">배송일</div>
                  <div class="col-8">
                    <input type="date" class="form-control" v-model="newItem.dispatch_date" disabled/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4">받는사람</div>
                  <div class="col-8">
                    <input type="text" class="form-control" v-model="newItem.receiver" disabled/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4">통관번호</div>
                  <div class="col-8">
                    <input type="text" class="form-control" v-model="newItem.custom_number" disabled/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4">주민번호</div>
                  <div class="col-8">
                    <input type="text" class="form-control" v-model="newItem.national_id" disabled/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4">관세청구</div>
                  <div class="col-4">
                    <select class="form-control" v-model="newItem.who_pays_tax" disabled>
                      <option value="0">Default</option>
                      <option value="1">수취인</option>
                      <option value="2">발송인</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4">관세사비용청구</div>
                  <div class="col-4">
                    <select class="form-control" v-model="newItem.who_pays_inspection" disabled>
                      <option value="0">Default</option>
                      <option value="1">수취인</option>
                      <option value="2">발송인</option>
                    </select>
                  </div>
                </div>


              </div>
            </div>
            <div class="col-6">
              <div class="container">

                <div class="form-group row">
                  <div class="col-4 text-right">우편번호</div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="newItem.post_code" disabled/>
                  </div>

                </div>
                <div class="form-group row">
                  <div class="col-4 text-right">주소</div>
                  <div class="col-8">
                    <input type="text" class="form-control" v-model="newItem.address_1" disabled/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 text-right">상세주소</div>
                  <div class="col-8">
                    <input type="text" class="form-control" v-model="newItem.address_2" disabled/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 text-right">배송메모</div>
                  <div class="col-8">
                    <input type="text" class="form-control" v-model="newItem.note" disabled/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 text-right">
                    VALUE(USD):
                  </div>
                  <div class="col-4">
                    <input type="number" class="form-control" v-model="newItem.value" disabled/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 text-right">
                    SIZE:
                  </div>
                  <div class="col-4">
                    <label class="form-control text-left">{{newItem.volume_x}}cm x {{newItem.volume_y}}cm x {{newItem.volume_z}}cm</label>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 text-right">
                    CW:
                  </div>
                  <div class="col-4">
                    <label class="form-control text-left">{{newItem.volume_weight/100}}Kg</label>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 text-right">
                    GW:
                  </div>
                  <div class="col-4">
                    <label class="form-control text-left">{{newItem.measured_weight/100}}Kg</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <table class="table">
                <tr>
                  <th>브랜드</th>
                  <th>상품명</th>
                  <th>상품URL</th>
                  <th>HS Code</th>
                  <th>원산지</th>
                  <th>수량</th>
                  <th>단가</th>
                  <th>총</th>
                </tr>
                <tr v-for="(item, index) in newItem.list">
                  <td><input type="text" class="form-control" v-model="item.brand" disabled/></td>
                  <td><input type="text" class="form-control" v-model="item.product" disabled/></td>
                  <td><input type="text" class="form-control" v-model="item.site_url" disabled/></td>
                  <td>
                    <select class="form-control" v-model="item.hs_code" disabled>
                      <option value="-1">Select</option>
                      <option v-for="(country, index) in hsCodes" :value="country.val">{{country.title}}</option>
                    </select>
                  </td>
                  <td>
                    <input type="text" class="form-control" v-model="item.origin_country" disabled/>
                  </td>
                  <td><input type="number" class="form-control" v-model="item.amount" disabled/></td>
                  <td><input type="number" class="form-control" v-model="item.value" disabled/></td>
                  <td>{{item.amount*item.value}}</td>
                </tr>
              </table>

            </div>
          </div>

          <div class="row fixed-bottom bottom-menu">
            <div class="col-12">
              <div class="bottom-button neutral-btn" v-on:click="closeNewItemForm()">Close</div>
            </div>

          </div>
        </div>
      </div>
    </div>
    </transition>

    <v-dialog/>
  </div>
</template>
<script>
    require('@/assets/css/styles.css')

    import Router from '../router';
    import VModal from '../router';
    import axios from 'axios';
    import {getStateString, downloadFTADoc, downloadFTADocMulti, getStateTimeString, getStatusString, moveToStatusPage} from '../api/Utils'
    import moment from 'moment'

    export default {
        name: 'Home',
        data() {
            return {
                msg: 'Home',
                isMobile: false,
                user: {
                    id: 0,

                },
                forwarders: [],
                hsCodes: [],
                items: [],
                newItem: false,
                filter: {
                    date_from: '',
                    date_to: '',
                    awb: '',
                    receiver: '',
                },
                showAll:false,
                stateOrderAsc: false,
                isCheckAll: false,
                selectedItems: [],
            }
        },
        created: function () {
            this.$data.isMobile = isFromMobile();
            document.addEventListener("backbutton", this.backButtonHandler, false);
            this.$data.user.id = localStorage.getItem('id');
            this.getForwarderList();
        },
        mounted: function () {
            //this.getPendingList();
        },
        updated: function () {
            console.log("content updated");
        },
        beforeDestroy() {
            document.removeEventListener("backbutton", this.backButtonHandler);
        },
        methods: {
            backButtonHandler: function () {
                console.log("back button pressed");
                if (this.$data.newItem != false) {
                    this.$data.newItem = false;
                }
            },
            logout: function () {
                let self = this;
                this.$modal.show('dialog', {
                    //title: '로그아웃',
                    text: '로그아웃 하시겠습니까?',
                    buttons: [
                        {
                            title: '아니요',
                            handler: () => {
                                self.$modal.hide('dialog');

                            }
                        },
                        {
                            title: '로그아웃',
                            handler: () => {
                                self.$modal.hide('dialog');
                                self.onLogoutConfirmed();
                            }
                        },

                    ]

                });
            },
            onLogoutConfirmed: function () {
                localStorage.removeItem('id');
                localStorage.removeItem('email');
                localStorage.removeItem('level');
                localStorage.removeItem('admin');
                localStorage.removeItem('password');
                Router.push('/');
            },
            showModal: function (title, message) {
                console.log("show modal " + title + " : " + message);
                this.$modal.show('dialog', {
                    title: title,
                    text: message,
                    buttons: [
                        {title: 'Close'}
                    ]
                })
                return;
            },
            openStatusPage: function(awb) {
                moveToStatusPage(awb);
            },
            getForwarderList: function () {
                var self = this;
                console.log("getForwarderList");
                var url = process.env.APP_URL + 'api/get_customer_meta.php?customer_id=' + this.$data.user.id;
                axios.get(url)
                    .then(response => {
                        console.log(response);
                        var data = response.data;
                        if (data.success) {
                            self.$data.forwarders = data.forwarders;
                            console.log("forwarders set");
                            console.log(self.$data.forwarders);
                            self.$data.countries = data.countries;
                            self.$data.hsCodes = data.hs_code;
                        }
                    })
                    .catch(error => {

                    });
            },

            getForwarderString: function (id) {
                for (var i = 0; i < this.$data.forwarders.length; i++) {
                    if (this.$data.forwarders[i].id == id) {
                        return this.$data.forwarders[i].title;
                    }
                }
                return 'Unknown';
            },
            getHsCodeString: function (val) {
                for (var i = 0; i < this.$data.hsCodes.length; i++) {
                    if (this.$data.hsCodes[i].val == val) {
                        return this.$data.hsCodes[i].title;
                    }
                }
                return 'Unknown';
            },
            ftaString: function () {
                if (this.$data.newItem == false) {
                    return '';
                }
                for (var i = 0; i < this.$data.countries.length; i++) {
                    if (this.$data.countries[i].title == this.$data.newItem.origin_country) {
                        return 'FTA';
                    }
                }
                return '';
            },
            getList: function () {
                var self = this;
                var url = process.env.APP_URL + 'api/get_items.php?customer_id=' + this.$data.user.id;
                url += '&state_greater=1'
                if (this.$data.filter.receiver.length > 0) {
                    url += '&receiver=' + this.$data.filter.receiver;
                } else if (this.$data.filter.awb.length > 0) {
                    url += '&awb=' + this.$data.filter.awb;
                } else if (this.$data.filter.date_from.length > 0 && this.$data.filter.date_to.length > 0) {
                    url += '&date_from=' + this.$data.filter.date_from + '&date_to=' + this.$data.filter.date_to;
                }
                console.log("getList " + url);
                axios.get(url)
                    .then(response => {
                        console.log("Get Pending");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            self.$data.items = data.items;
                            for (var i = 0; self.$data.items.length; i++) {
                                self.$data.items[i].list = JSON.parse(self.$data.items[i].list);
                            }
                        } else {

                        }
                    })
                    .catch(error => {

                    });
            },

            viewItem: function (index) {
                this.$data.newItem = this.$data.items[index];

            },

            closeNewItemForm: function () {
                this.$data.newItem = false;

            },
            getTodayData: function () {
                var myDate = new Date();
                var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
                var date = ('0' + myDate.getDate()).slice(-2);
                var year = myDate.getFullYear();
                var formattedDate = year + '-' + month + '-' + date;
                return formattedDate;
            },
            getStateString: function(state) {
                return getStateString(state);
            },
            getStateTimeString: function(index) {
                return getStateTimeString(this.$data.items[index]) + '<span class="tooltiptext text-left"'+ this.getStatusTooltip(index) + '</span>';
            },
            getStatusTooltip: function(index) {
                return getStatusString(this.$data.items[index]);
            },
            getDescriptionList: function(list) {
                let text  = "";
                if(list.length > 0) {

                    text += list[0].origin_country + " " + list[0].product;

                    if(list.length > 1) {
                        text += " 외 " + list.length + "건";
                    }
                }
                return text;
            },
            getFTADoc: function(id) {

                console.log("Search " + id);
                downloadFTADoc(id);
            },
            getFTADocsForSelected: function() {
              if(this.$data.selectedItems.length > 0) {


                let idList = [];
                for(let i = 0 ; i < this.$data.selectedItems.length && i < 50; i++) {
                  idList.push(this.$data.items[this.$data.selectedItems[i]].id);
                }
                let ids = idList.join(',');
                downloadFTADocMulti(ids);
                this.$data.selectedItems.splice(0, idList.length);
                if(this.$data.selectedItems.length > 0) {
                  window.alert("한번에 받을 수 있는 FTA서류는 50개까지 입니다. 나머지 " + this.$data.selectedItems.length + "개 항목은 그대로 선택되어 있습니다. FTA버튼을 클릭하시면 추가로 받으실 수 있습니다");
                }
              }
                // if(this.$data.selectedItems.length > 0) {
                //     let ids = this.$data.selectedItems.join(',');
                //     downloadFTADocMulti(ids);
                //     this.$data.selectedItems = [];
                // }
            },
            sortByAWB: function() {
                if(this.$data.items.length  == 0) {
                    return;
                }
                this.$data.items.sort(function(a, b){
                    if(a.awb > b.awb) {
                        return 1;
                    }
                    return -1;
                })
            },
            sortByReceiver: function() {
                if(this.$data.items.length  == 0) {
                    return;
                }
                this.$data.items.sort(function(a, b){
                    if(a.receiver > b.receiver) {
                        return 1;
                    }
                    return -1;
                })
            },
            sortByState: function() {
                this.$data.stateOrderAsc = !this.$data.stateOrderAsc;
                if(this.$data.items.length  == 0) {
                    return;
                }
                let self = this;
                this.$data.items.sort(function(a, b){
                    if(a.state > b.state) {
                        if(self.$data.stateOrderAsc == true) {
                            return -1;
                        } else {
                            return 1;
                        }
                    }
                    if(self.$data.stateOrderAsc == true) {
                        return 1;
                    }
                    return -1;
                })
            },
            downloadForCustomerH: function () {
                var url = 'static/customer_form_horizontal.xlsx';
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.responseType = "arraybuffer";

                var self = this;
                req.onload = function (e) {
                    var data = new Uint8Array(req.response);
                    var workbook = XLSX.read(data, {type: "array"});

                    /* DO SOMETHING WITH workbook HERE */
                    var worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    var test = XLSX.utils.sheet_to_json(worksheet);
                    console.log("TEst data");
                    console.log(test);
                    var results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                    console.log("Read data");
                    console.log(results);
                    var row = results[0];
                    var header = [];
                    for (var key in row) {
                        header.push(key);
                    }
                    var newList = [];
                    //newList.push(header);
                    for (var i = 0; i < self.$data.items.length; i++) {
                        var dataItem = self.$data.items[i];
                        let whoPaysFee = '수취인';
                        if(dataItem["who_pays_inspection"] == 2) {
                            whoPaysFee = '발송인';
                        }
                        var item = [dataItem["order_number"], dataItem["awb"], dataItem["dispatch_date"],
                            dataItem["sender"], dataItem["sender_contact"], dataItem["sender_post_code"], dataItem["sender_address_1"] + " " + dataItem["sender_address_2"],
                            dataItem["receiver"], dataItem["receiver_contact"], dataItem["receiver_contact"], dataItem["post_code"], dataItem["address_1"], "", dataItem["custom_number"], dataItem['memo'],
                            (dataItem["measured_weight"] / 100).toFixed(2), (dataItem["weight"] / 100).toFixed(2), dataItem["ct"], whoPaysFee, dataItem["memo1"], dataItem["memo2"]];


                        var list = self.$data.items[i].list;
                        for (var j = 0; j < list.length; j++) {
                            item.push(list[j].product);
                            item.push(list[j].amount);
                            item.push(list[j].value);
                            item.push(list[j].brand);
                            item.push(list[j].url);
                            item.push(list[j].hs_code);
                            item.push(list[j].origin_country);
                        }

                        newList.push(item);
                    }

                    XLSX.utils.sheet_add_aoa(worksheet, newList, {origin: -1});


                    var sheet = XLSX.utils.json_to_sheet(newList)

                    // A workbook is the name given to an Excel file
                    var wb = XLSX.utils.book_new() // make Workbook of Excel

                    // add Worksheet to Workbook
                    // Workbook contains one or more worksheets
                    XLSX.utils.book_append_sheet(wb, worksheet, 'sheet1') // sheetAName is name of Worksheet

                    // export Excel file
                    var fileName = "UTASCO-" + moment(new Date()).format("YYYYMMDD-hhmmss") + '.xlsx';
                    XLSX.writeFile(wb, fileName); // name of the file is book.xlsx
                }

                req.send();
                console.log("DW form");


            },
            downloadForCustomerV: function () {
                var url = 'static/customer_form_vertical.xlsx';
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.responseType = "arraybuffer";

                var self = this;
                req.onload = function (e) {
                    var data = new Uint8Array(req.response);
                    var workbook = XLSX.read(data, {type: "array"});

                    /* DO SOMETHING WITH workbook HERE */
                    var worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    var test = XLSX.utils.sheet_to_json(worksheet);
                    console.log("TEst data");
                    console.log(test);
                    var results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                    console.log("Read data");
                    console.log(results);
                    var row = results[0];
                    var header = [];
                    for (var key in row) {
                        header.push(key);
                    }
                    var newList = [];
                    //newList.push(header);
                    for (var i = 0; i < self.$data.items.length; i++) {
                        var dataItem = self.$data.items[i];
                        let whoPaysFee = '수취인';
                        if(dataItem["who_pays_inspection"] == 2) {
                            whoPaysFee = '발송인';
                        }
                        var item = [dataItem["order_number"], dataItem["awb"], dataItem["dispatch_date"],
                            dataItem["sender"], dataItem["sender_contact"], dataItem["sender_post_code"], dataItem["sender_address_1"] + " " + dataItem["sender_address_2"],
                            dataItem["receiver"], dataItem["receiver_contact"], dataItem["receiver_contact"], dataItem["post_code"], dataItem["address_1"], "", dataItem["custom_number"], dataItem['note'],
                            (dataItem["measured_weight"] / 100).toFixed(2), (dataItem["weight"] / 100).toFixed(2), dataItem["ct"], whoPaysFee, dataItem["memo1"], dataItem["memo2"]];


                        var list = self.$data.items[i].list;
                        for (var j = 0; j < list.length; j++) {
                            if(j > 0) {
                                item = [
                                    "", "", "",
                                    "", "", "", "",
                                    "", "", "", "", "", "", "", "",
                                    "", "", "", "", "", ""];

                            }
                            item.push(list[j].product);
                            item.push(list[j].amount);
                            item.push(list[j].value);
                            item.push(list[j].brand);
                            item.push(list[j].url);
                            item.push(list[j].hs_code);
                            item.push(list[j].origin_country);
                            newList.push(item);
                        }


                    }

                    XLSX.utils.sheet_add_aoa(worksheet, newList, {origin: -1});


                    var sheet = XLSX.utils.json_to_sheet(newList)

                    // A workbook is the name given to an Excel file
                    var wb = XLSX.utils.book_new() // make Workbook of Excel

                    // add Worksheet to Workbook
                    // Workbook contains one or more worksheets
                    XLSX.utils.book_append_sheet(wb, worksheet, 'sheet1') // sheetAName is name of Worksheet

                    // export Excel file
                    var fileName = "UTASCO-" + moment(new Date()).format("YYYYMMDD-hhmmss") + '.xlsx';
                    XLSX.writeFile(wb, fileName); // name of the file is book.xlsx
                }

                req.send();
                console.log("DW form");


            },
            exportExcel: function () {
                var url = 'static/daewoon-form.xlsx';
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.responseType = "arraybuffer";

                var self = this;
                req.onload = function (e) {
                    var data = new Uint8Array(req.response);
                    var workbook = XLSX.read(data, {type: "array"});

                    /* DO SOMETHING WITH workbook HERE */
                    var worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    var test = XLSX.utils.sheet_to_json(worksheet);
                    console.log("TEst data");
                    console.log(test);
                    var results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                    console.log("Read data");
                    console.log(results);
                    var row = results[0];
                    var header = [];
                    for (var key in row) {
                        header.push(key);
                    }
                    var newList = [];
                    //newList.push(header);
                    for (var i = 0; i < self.$data.items.length; i++) {
                        var dataItem = self.$data.items[i];
                        let whoPaysFee = '수취인';
                        if(dataItem["who_pays_inspection"] == 2) {
                            whoPaysFee = '발송인';
                        }
                        var item = [dataItem["order_number"], dataItem["awb"], dataItem["dispatch_date"],
                            dataItem["sender"], dataItem["sender_contact"], dataItem["sender_post_code"], dataItem["sender_address_1"] + " " + dataItem["sender_address_2"],
                            dataItem["receiver"], dataItem["receiver_contact"], dataItem["receiver_contact"], dataItem["post_code"], dataItem["address_1"], "", dataItem["custom_number"], dataItem['memo'],
                            (dataItem["measured_weight"] / 100).toFixed(2), (dataItem["weight"] / 100).toFixed(2), dataItem["ct"], whoPaysFee];


                        var list = self.$data.items[i].list;
                        for (var j = 0; j < list.length; j++) {
                            item.push(list[j].product);
                            item.push(list[j].amount);
                            item.push(list[j].value);
                            item.push(list[j].brand);
                            item.push(list[j].url);
                            item.push(list[j].hs_code);
                        }

                        newList.push(item);
                    }

                    XLSX.utils.sheet_add_aoa(worksheet, newList, {origin: -1});


                    var sheet = XLSX.utils.json_to_sheet(newList)

                    // A workbook is the name given to an Excel file
                    var wb = XLSX.utils.book_new() // make Workbook of Excel

                    // add Worksheet to Workbook
                    // Workbook contains one or more worksheets
                    XLSX.utils.book_append_sheet(wb, worksheet, 'sheet1') // sheetAName is name of Worksheet

                    // export Excel file
                    var fileName = "UTASCO-List-" + self.$data.filter.date_from + '-' + self.$data.filter.date_to + '-' + moment(new Date()).format("YYYYMMDD-hhmmss") + '.xlsx';
                    XLSX.writeFile(wb, fileName); // name of the file is book.xlsx
                }

                req.send();
                console.log("DW form");


            },
            selectAll: function () {
                this.$data.isCheckAll = !this.$data.isCheckAll;
                this.$data.selectedItems = [];
                var unselectableFound = false;
                if (this.$data.isCheckAll) {
                    for (var key in this.$data.items) {
                        this.$data.selectedItems.push(key)

                    }
                }

            },
            updateCheckall: function (e, index) {
                console.log("updateCheckall");
                if (e.shiftKey) {
                    console.log("shif key clicked");
                    let lastIndex = 0;
                    if(this.$data.selectedItems.length > 0) {
                        lastIndex = this.$data.selectedItems[this.$data.selectedItems.length-1];
                    }

                    if(index > lastIndex) {
                        for(let i = lastIndex+1 ; i < index ; i++) {
                            let found = false;
                            for(let j = 0 ; j < this.$data.selectedItems.length ; j++) {
                                if(this.$data.selectedItems[j] === i) {
                                    this.$data.selectedItems.splice(j, 1);
                                    found = true;
                                    break;
                                }
                            }
                            if(found == false) {
                                this.$data.selectedItems.push(i);
                            }
                        }
                    } else {
                        for(let i = index+1 ; i < lastIndex ; i++) {
                            let found = false;
                            for(let j = 0 ; j < this.$data.selectedItems.length ; j++) {
                                if(this.$data.selectedItems[j] === i) {
                                    this.$data.selectedItems.splice(j, 1);
                                    found = true;
                                    break;
                                }
                            }
                            if(found == false) {
                                this.$data.selectedItems.push(i);
                            }
                        }
                    }
                }

                if (this.$data.selectedItems.length == this.$data.items.length) {
                    this.$data.isCheckAll = true;
                } else {
                    this.$data.isCheckAll = false;
                }
                console.log("check");
                console.log(this.$data.selectedItems);
            },

        },


    }
</script>
<style lang="css" scoped>
  .table td {
    padding:.25rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/History.vue